/**
 * `contractorLog` translations, for every locale. The nav label `app.contractorLog` lives in shell.ts.
 */
export const contractorLog = {
  mn: {
    contractorLog: {
      blurb: 'Өдрийн болон цагийн хөлстэй гэрээт ажилтныг сонгоод, хуанлийн өдөр дээр дарж ажилласан өдөр (0-1), цагийг оруулна; хадгалсан бүртгэл шууд цалинд тооцогдоно. Хуваарийн өдөр зөвхөн энд бүртгэгдсэн бол цалинд орно.',
      closed: 'Энэ цалингийн сар хаагдсан тул бүртгэлийг өөрчлөх боломжгүй.',
      loadFailed: 'Гэрээт ажилтны бүртгэлийг ачаалж чадсангүй',
      none: 'Энэ сард танд харагдах гэрээт ажилтан алга.',
      you: '(та)',
      contractor: 'Гэрээт ажилтан',
      monthTotal: 'Сарын нийт',
      notEntered: 'Оруулаагүй',
      cellEntered: '{{days}} өдөр, {{hours}} цаг',
      daysShort: '{{value}} өд',
      hoursShort: '{{value}} ц',
      savedToast: 'Хадгаллаа',
      deletedToast: 'Устгалаа',
      saveFailed: '{{date}}-ны бүртгэлийг хадгалж чадсангүй',
      deleteFailed: '{{date}}-ны бүртгэлийг устгаж чадсангүй',
      days: 'Өдөр',
      hours: 'Цаг',
      note: 'Тэмдэглэл',
      error: {
        daysRange: 'Өдөр 0-1 хооронд, хамгийн ихдээ хоёр орны нарийвчлалтай байна (жишээ нь 0.75).',
        hoursRange: 'Цаг 0-24 хооронд, хамгийн ихдээ хоёр орны нарийвчлалтай байна.',
        empty: 'Өдөр, цаг эсвэл хоёуланг нь оруулна уу.',
      },
    },
  },
  en: {
    contractorLog: {
      blurb: 'Pick a daily+hourly contractor, then click a day on the calendar to enter their days (0 to 1) and hours; a saved entry counts for pay at once. A roster day is paid only when it is entered here.',
      closed: 'This payroll month is closed, so its log can no longer change.',
      loadFailed: 'Could not load the contractor log',
      none: 'No contractors for you to see this month.',
      you: '(you)',
      contractor: 'Contractor',
      monthTotal: 'Month total',
      notEntered: 'Not entered',
      cellEntered: '{{days}} days, {{hours}} hours',
      daysShort: '{{value}} d',
      hoursShort: '{{value}} h',
      savedToast: 'Saved',
      deletedToast: 'Deleted',
      saveFailed: 'Could not save the entry for {{date}}',
      deleteFailed: 'Could not delete the entry for {{date}}',
      days: 'Days',
      hours: 'Hours',
      note: 'Notes',
      error: {
        daysRange: 'Days run from 0 to 1, with at most two decimals (e.g. 0.75).',
        hoursRange: 'Hours run from 0 to 24, with at most two decimals.',
        empty: 'Enter days, hours, or both.',
      },
    },
  },
  ru: {
    contractorLog: {
      blurb: 'Выберите подрядчика с дневной и почасовой ставкой и нажмите на день в календаре, чтобы внести дни (от 0 до 1) и часы; сохранённая запись сразу идёт в расчёт. День из графика оплачивается, только если он внесён здесь.',
      closed: 'Этот расчётный месяц закрыт, журнал больше нельзя изменить.',
      loadFailed: 'Не удалось загрузить журнал подрядчиков',
      none: 'В этом месяце нет подрядчиков, доступных вам.',
      you: '(вы)',
      contractor: 'Подрядчик',
      monthTotal: 'Итого за месяц',
      notEntered: 'Не внесено',
      cellEntered: '{{days}} дн., {{hours}} ч',
      daysShort: '{{value}} дн',
      hoursShort: '{{value}} ч',
      savedToast: 'Сохранено',
      deletedToast: 'Удалено',
      saveFailed: 'Не удалось сохранить запись за {{date}}',
      deleteFailed: 'Не удалось удалить запись за {{date}}',
      days: 'Дни',
      hours: 'Часы',
      note: 'Примечания',
      error: {
        daysRange: 'Дни от 0 до 1, не более двух знаков после запятой (например, 0.75).',
        hoursRange: 'Часы от 0 до 24, не более двух знаков после запятой.',
        empty: 'Укажите дни, часы или и то и другое.',
      },
    },
  },
}
